import React from 'react';
import Form, {DateInput, FormActions, FormBody, SelectInput} from "../../../Form";
import FormMultiSelectInput from "../../../FormMultiSelectInput";
import {inject, observer} from 'mobx-react';
import {observable, action} from 'mobx';
import moment from "moment";
import GraphView from "../../../GraphView";
import {analysis as api} from "../../../../actions/api";
import _ from 'lodash';
import Spinner from "../../../Spinner";

@inject('stationStore', 'parameterStore')
@observer
class DoubleMassCurve extends React.Component {
  autoFillForm = process.env.NODE_ENV !== 'production';

  @observable compareStationOptions = [];
  @observable periodOptions = [{label: 'Hourly', value: 0}, {label: 'Daily', value: 1}, {label: 'Monthly', value: 2}];
  @observable isLoading = false;

  @observable input = {
    station: this.autoFillForm ? 78 : '',
    parameter: this.autoFillForm ? 97 : '',
    dateFrom: moment().subtract(7, 'days'),
    dateTo: moment(),
    period: 1
  };

  @observable observations = null;

  componentWillMount() {
    const {stationStore, parameterStore} = this.props;

    if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();

    this.populateOptions();
  }

  getDailyAvg = (observationData) => new Promise((resolve, reject) => {
    // console.log(observationData)
    if (observationData.length === 0) resolve([]);
    let format = '';
    switch (this.input.period) {
      case 1:
        format = 'YYYY-MM-DDT00:00:00';
        break;
      case 2:
        format = 'YYYY-MM-00T00:00:00';
        break;
      case 0:
        format = 'YYYY-MM-DDTHH:00:00';
        break;
      default: 
        format = 'YYYY-MM-DDTHH:mm:ss'
        break;
    }
    let compareArray = [];
    let catArrItem;
    let getCat = (time) => moment(time).format(format);
    let catArr = [];
    observationData.length && observationData.map(item => {
      let cat = [];
      catArr = _.groupBy(item && item.parameters && item.parameters[0].data, n => getCat(n.time));
      let Arrkeys = Object.keys(catArr);
      Arrkeys.map(key => {
        let values = catArr[key].map(item => item.value);
        let avg = _.mean(values);
        catArrItem = {
          datetime: key,
          value: avg
        };
        return cat.push(catArrItem)
      });

      return compareArray.push({
        name: item && item.name,
        data: cat
      })
    });
    // console.log(compareArray)

    resolve(compareArray)
  });

  getCumulativeFreq = (observationData) => new Promise((resolve, reject) => {
    // console.log(observationData)
    let CfData = [], cf = 0;
    if (observationData.length === 0) resolve([]);
    else if (observationData.length > 1) {
      observationData && observationData.forEach(item => {
        cf = cf + item.value;
        CfData.push({
          datetime: item.datetime,
          value: cf
        })
      })
      // console.log(CfData, 'sec')
    } else {
      // observationData[0].data === undefined && alert('select correct date for month')
      observationData && observationData.forEach(station =>
        station && station.data.forEach(item => {
          cf = cf + item.value;
          CfData.push({
            datetime: item.datetime,
            value: cf
          })
        }))
      // console.log(CfData, 'fir')
    }
    // console.log(CfData)
    resolve(CfData)
  });

  getMean = (observationData) => new Promise((resolve, reject) => {
    if (observationData.length === 0) resolve([]);
    let avgArr = [];
    observationData.map(station => {
      return station.data.map(item => {
        let prev = avgArr.find(x => x.datetime === item.datetime);
        if (!!prev) {
          prev.value = (prev.value + item.value) / 2
        }
        else
          return avgArr.push(item)
      })
    });

    resolve(avgArr)

  });

  populateOptions = () => {
    const {stationStore, parameterStore} = this.props;
    if (stationStore.items.length === 0 || parameterStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      this.compareStationOptions = stationStore.items.map(item => ({
        id: item.id,
        label: item.name,
        value: this.autoFillForm ? (+item.id === 78 || +item.id === 227 || +item.id === 165) : false,
        tags: item.tags
      }));
      // this.multiParameterOptions = parameterStore.items.map(item => ({id: item.id, label: item.name, value: false}));
    }
  };

  @action onChangeInput = (field, value) => this.input[field] = value;
  @action onCompareStationSelect = item => item.value = !item.value;

  onView = async (e) => {
    e.preventDefault();
    const {station, parameter, dateFrom, dateTo, period} = this.input;
    const compareStations = this.compareStationOptions.filter(item => !!item.value).map(item => item.id);

    if (!station || !parameter || !dateFrom || !dateTo || !period || !compareStations.length) return null;

    let observations = {
      station: null,
      compare: null
    };
    this.isLoading = true;
    this.observations = null;

    let responses = await Promise.all([
      api.fetchMore({stations: station, parameters: parameter, date_from: dateFrom, date_to: dateTo})
        .then(this.getDailyAvg)
        .then(this.getCumulativeFreq),
      api.fetchMore({stations: compareStations.join(','), parameters: parameter, date_from: dateFrom, date_to: dateTo})
        .then(this.getDailyAvg)
        .then(this.getMean)
        .then(this.getCumulativeFreq)
    ]);

    this.isLoading = false;

    observations.station = responses[0];
    observations.compare = responses[1];

    this.observations = observations;

  };

  getGraphOptions = observations => {
    const {stationStore, parameterStore} = this.props;
    let yLabel = stationStore.findById(this.input.station).name,
        xLabel = this.compareStationOptions.filter(item => !!item.value).map(item => stationStore.findById(item.id).name).join(', '),
        title = parameterStore.findById(this.input.parameter).name;
    let array = [];

    observations.compare && observations.compare.forEach(itemM => {
      let itemS = observations.station.find(item => item.datetime === itemM.datetime);
      if (!!itemS) array.push({
        datetime: itemS.datetime,
        value: [itemM.value, itemS.value]
      });
      // observations.station && observations.station.forEach(itemS => {
      //   if (itemM.datetime === itemS.datetime) {
      //     array.push({
      //       datetime: itemS.datetime,
      //       value: [itemM.value, itemS.value]
      //     })
      //   }
      // });
    });


    return {
      chart: {
        zoomType: 'x',
        type: 'spline'
      },
      title: {
        text: title
        // text: this.state.dataChart.parameter_name
      },
      xAxis: {
        title: {
          // text: `Average Cumulative`,
          text: xLabel
        },
      },
      yAxis: {
        title: {
          // text: 'Single Station Cumulative',
          text: yLabel
        }
      },
      tooltip: {
        formatter: function (tooltip, x = this.x, points = this.points) {
          let s = `<b>x: ${x}</b>`;
          points.forEach(point =>
            s += `<br/><b>y: ${point.y}</b>`
          );
          return s;
        },
        shared: true
      },

      credits: {
        enabled: false
      },
      series: [{
        name: 'Point',
        data: array && array.map(data => data.value),
      }],
      legend: false
    };
  };

  render() {
    const {stationStore, parameterStore} = this.props;
    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='Station' options={stationStore.items} fields={{value: 'id', label: 'name'}}
                         value={this.input.station} onChange={e => this.onChangeInput('station', +e.target.value)}/>
            <FormMultiSelectInput id='dmc-compare-station-multi-select' label='Compare Station'
                                  options={this.compareStationOptions} optionClicked={this.onCompareStationSelect}/>
            <SelectInput label='Parameter' options={parameterStore.items} fields={{value: 'id', label: 'name'}}
                         value={this.input.parameter} onChange={e => this.onChangeInput('parameter', +e.target.value)} 
                         filterOptions={parameterStore.filterParameters}/>
            <DateInput
              label={'Date From'}
              type="datetime-local"
              value={moment(this.input.dateFrom).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeInput('dateFrom', e.target.value)}
            />
            <DateInput
              label={'Date To'}
              type="datetime-local"
              value={moment(this.input.dateTo).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeInput('dateTo', e.target.value)}
            />
            <SelectInput label='Period' options={this.periodOptions} fields={{value: 'value', label: 'label'}}
                         value={this.input.period} onChange={e => this.onChangeInput('period', +e.target.value)}/>
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
          </FormActions>
        </Form>
        {this.isLoading && <Spinner/>}
        {this.observations && <GraphView options={this.getGraphOptions(this.observations)}/>}
      </div>
    );
  }
}

export default DoubleMassCurve;/**
 * Created by Suhel Shrestha on 8/30/19
 */


// WEBPACK FOOTER //
// ./src/components/Analysis/Tools/DoubleMassCurve/DoubleMassCurve.js